import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { RedeemedCouponCode } from "@roman/shared/types/Coupon";
import useSWRMutation from "swr/mutation";

type Arg = {
  code: string;
};

const fetcher = (url: string, { arg }: { arg: Arg }) => {
  const headers = authHeader.getOrThrow();
  return romanApi.post<RedeemedCouponCode, Arg>(url, arg, { headers });
};

export const useRedeemCoupon = (
  useHandleError: (msg: string) => (err: RomanApiError) => void,
  handleError?: (err: RomanApiError) => void,
) => {
  const effectiveHandleError = handleError ?? useHandleError("クーポンの利用に失敗しました");

  const { data, error, trigger, isMutating } = useSWRMutation("/coupons/redeem", fetcher, {
    onError: effectiveHandleError,
  });

  return {
    data,
    error,
    isMutating,
    trigger,
  };
};
